import React, { useEffect, useRef } from "react";
import styles from "./Skills.module.scss";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Skills = () => {
  const skillsRef = useRef(null);
  const titleRef = useRef(null);
  const columnsRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Animate title entrance
    gsap.fromTo(
      titleRef.current,
      {
        opacity: 0,
        x: -100,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: skillsRef.current,
          start: "top 80%",
        },
      }
    );

    // Animate skills columns
    gsap.fromTo(
      columnsRef.current.children,
      {
        opacity: 0,
        y: 50,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: skillsRef.current,
          start: "top 70%",
        },
      }
    );
  }, []);

  const skillsData = {
    Frontend: [
      "Next.js",
      "React.js",
      "React Native",
      "Three.js",
      "Web3.js",
      "Scokets.io",
      "TailwindCSS",
      "JavaScript",
      "TypeScript",
      "Git",
    ],
    Backend: [
      "Node.js",
      "Express.js",
      "MySQL",
      "Postman",
      "Alchemy",
      "Solidity",
      "Smart Contracts",
    ],
    "Deployment": [
      "Vercel",
      "AWS",
      "Google Cloud",
    ],
  };

  return (
    <div ref={skillsRef} className={styles.skills}>
      <div className={styles.container}>
        <div ref={titleRef} className={styles.titleSection}>
          <h1 className={styles.mainTitle}>
            DEVELOPER
            <br />
            DESIGNER
            <br />
            CREATOR/
          </h1>
        </div>

        <div className={styles.skillsSection}>
          <h2 className={styles.skillsTitle}>Skills</h2>

          <div ref={columnsRef} className={styles.skillsGrid}>
            {Object.entries(skillsData).map(([category, skills], index) => (
              <div key={index} className={styles.skillColumn}>
                <h3 className={styles.categoryTitle}>{category}</h3>
                <ul className={styles.skillsList}>
                  {skills.map((skill, skillIndex) => (
                    <li key={skillIndex} className={styles.skillItem}>
                      {skill}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
